import { render, staticRenderFns } from "./EsgDisclosureTemplateManagementGrid.vue?vue&type=template&id=bc2e2f96&scoped=true"
import script from "./EsgDisclosureTemplateManagementGrid.vue?vue&type=script&lang=js"
export * from "./EsgDisclosureTemplateManagementGrid.vue?vue&type=script&lang=js"
import style0 from "./EsgDisclosureTemplateManagementGrid.vue?vue&type=style&index=0&id=bc2e2f96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2e2f96",
  null
  
)

export default component.exports